export default __webpack_public_path__ + "static/Continuous Integration 2-cfd0f8525209c1b0960ae6e4c76b8147.png";